import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'MonthFilter' })({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        gap: 4
    },
    button: {
        position: 'relative',
        textTransform: 'uppercase',
        padding: '12px 20px',
        borderRadius: 16,
        border: '1px solid #ECECEC',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: '-0.28px',
        opacity: 0.7,
        height: 44,
        transition: 'all 0.2s',
        '&:hover': {
            background: '#F8F8F8',
            borderColor: '#F8F8F8',
            opacity: 1
        },
        '&:after': {
            opacity: 0,
            transition: 'opacity 0.2s',
            position: 'absolute',
            bottom: 0,
            content: '""',
            width: 'calc(100% - 24px)',
            height: 4,
            borderRadius: '20px 20px 0px 0px',
            background: '#2D2D2D'
        }
    },
    _selected: {
        cursor: 'default',
        pointerEvents: 'none',
        background: '#F8F8F8',
        borderColor: '#F8F8F8',
        opacity: 1,
        '&:after': {
            opacity: 1
        }
    }
});
